<script setup lang="ts">
  import { useScroll } from "@vueuse/core";
  import { useTranslation } from 'i18next-vue';
  import { useTemplateRef } from 'vue';
  import { useThemeStore } from '#/store/theme';
  import type { IProduct } from '#/types/iCardProduct';
  import { getLocaleName } from '#/utils/i18next';

  defineProps<{
    text: string;
    items: IProduct[];
  }>();
  const emit = defineEmits<{ (e: 'accept'): void }>();

  const scrollerRef = useTemplateRef<HTMLDivElement>("scrollerRef");

  const { t, i18next } = useTranslation();
  const { arrivedState } = useScroll(scrollerRef);

  const themeStore = useThemeStore();

</script>

<template>
  <Transition name="markedNoticeBlack" appear>
    <div class="marked_notice_backdrop"></div>
  </Transition>
  <Transition name="markedNotice" appear>
    <div class="marked_notice_overlay">
      <div
        class="marked_notice_wrapper"
        :style="{
          'background-color': themeStore.data?.accent_color || '#FF6D2E',
          border: `2px solid ${themeStore.data?.accent_color || '#FF6D2E'}`,
        }"
      >
        <div class="marked_notice_info">
          <p class="marked_notice_text">{{ text }}</p>
          <div class="marked_notice_list_wrapper" :data-arrived-start="arrivedState.top" :data-arrived-end="arrivedState.bottom">
            <ul class="marked_notice_list" ref="scrollerRef">
              <li
                v-for="item in items"
                :key="item.idSystem || item.id"
                class="marked_notice_item"
              >
                <span class="marked_notice_item_name">{{ getLocaleName(item, i18next.language) }}</span>
                <span class="marked_notice_item_amount">× {{ item.amount }}</span>
              </li>
            </ul>
          </div>
          <div class="marked_notice_button_wrap">
            <button
              class="marked_notice_accept"
              type="button"
              @click="emit('accept')"
            >
              {{ t(`marked-items-notice.button.close`) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss">
  @use './markedItemsNotice.scss';
</style>